const Classes = {
  DETAIL_SUBCRIBE_BUTTON: 'detail-subscribe-button',
  DETAIL_THUMBS_UP_BUTTON: 'detail-thumbs-up-button',
  DETAIL_THUMBS_UP_ICON: 'detail-thumbs-up-icon',
  DETAIL_THUMBS_DOWN_BUTTON: 'detail-thumbs-down-button',
  DETAIL_REPORT_BUTTON: 'detail-report-button',
  BASE_BUTTON_ICON: 'base-button-icon',
  LOGIN_OPTIONS_MODAL: 'login-options-modal',
  LOADING_MODAL: 'loading-modal',
  LOGIN_EMAIL_MODAL: 'login-email-modal',
  MODAL_CLOSE_BUTTON: 'modal-close-button',
  GAME_TILE_SUBSCRIBE_BUTTON: 'game-tile-subscribe-button',
  DEPENDENCY_SUBSCRIBE_BUTTON: 'dependency-subscribe-button',
  GAME_TILE_IMAGE: 'game-tile-image',
  GAME_TILE_GRID: 'game-tile-grid',
  GAME_TILE: 'tile',
  CONTAINER: 'container',
  NAVBAR: 'navbar',
  USER_NAVBAR: 'user-navbar',
  TAB: 'tab',
  AVATAR: 'avatar',
  FILTERS: 'filters',
  HERO_IMAGE: 'hero-image',
  GALLERY_IMAGE: 'gallery-image',
  COMMENTS: 'comments',
  COMMENT: 'comment',
  SECTION: 'section',
  BUTTONS: 'buttons',
  SUMMARY: 'summary',
  RATING_BAR: 'rating-bar',
  TAGS: 'tags',
  TEAM: 'team',
  FILE: 'file',
  DEPENDENCIES: 'dependencies',
  DESCRIPTION: 'description',
  LIBRARY: 'library',
  TOOLTIP: 'tooltip',
  POPUP: 'popup',
  STATS: 'stats',
  STATBOX: 'statbox',
  DATE_ICON: 'date-icon',
  ONLINE_ICON: 'online-icon',
  FILE_DIVIDER: 'file-divider',
  RELEASES_LINK: 'releases-link',
  RELEASES_CONTENT: 'releases-content',
  RELEASES_PREVIOUS_BUTTON: 'releases-previous-button',
  CONTRIBUTOR: 'contributor',
  TEAM_MEMBER_BADGE: 'team-member-badge',
  TILE_SUMMARY: 'tile-summary',
  TILE_AUTHOR: 'tile-author',
  TILE_UPDATED_DATE: 'tile-updated-date',
  TILE_TAG_LIST: 'tile-tag-list',
  TILE_TAG: 'tile-tag',
  TILE_MOD_STATS: 'tile-mod-stats',
  TILE_GUIDE_STATS: 'tile-guide-stats',
  TILE_TITLE: 'tile-title',
}

export default Classes
